import { api, queryString } from '@sentinel/web-core';
import type {
  NotificationList,
  NotificationPreferences,
  NotificationPreferencesUpdate,
} from '@sentinel/shared';

type Ok = { status: 'ok' };

/** The caller's notifications in the active organization (CLAUDE.md §23). */
export const notificationEndpoints = {
  list: (params: { page: number; pageSize: number }) =>
    api<NotificationList>(`/notifications${queryString(params)}`),
  markRead: (id: string) => api<Ok>(`/notifications/${id}/read`, { method: 'POST' }),
  markAllRead: () => api<Ok>('/notifications/read-all', { method: 'POST' }),
  /** Which important kinds also reach the caller's inbox (ADR 0019). */
  preferences: () => api<NotificationPreferences>('/me/notification-preferences'),
  savePreferences: (body: NotificationPreferencesUpdate) =>
    api<NotificationPreferences>('/me/notification-preferences', { method: 'PUT', body }),
};
